import styled from 'styled-components';
import { FormField, FormFieldHeader } from 'ui/formField';
import { body1, colors, fontWeights, spacing } from 'ui/theme';

export const ReadOnlySettingsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${spacing.base};
`;

export const StyledSettingsFormField = styled(FormField)`
  width: 100%;
  display: flex;
  align-items: baseline;
  & + & {
    margin: 0;
  }
  ${FormFieldHeader} {
    min-width: ${spacing.x10};
    max-width: ${spacing.x10};
    margin: 0;
    label {
      font-weight: ${fontWeights.bold};
    }
  }
`;

export const StyledSettingsFieldValue = styled.div`
  ${body1}
  color: ${colors.textPrimary};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
  white-space: break-spaces;
`;
